export const Currencies = {
  USD: "USD",
  EUR: "EUR",
} as const;
export type Currency = (typeof Currencies)[keyof typeof Currencies];

export const AccountStatuses = {
  DRAFT: "DRAFT",
  CREATED: "CREATED",
  PENDING: "PENDING",
  CLOSED: "CLOSED",
  FROZEN: "FROZEN",
} as const;
export type AccountStatus =
  (typeof AccountStatuses)[keyof typeof AccountStatuses];

export interface CashBalanceDto {
  currency: Currency;
  available: number;
  status: AccountStatus;
}

export interface CashAccountResponseDto {
  shouldShowCashAccount: boolean;
  shouldShowCashAccountProcessing: boolean;
  cashBalances: CashBalanceDto[];
}
